import React, { useEffect, useState, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import SecBTN from "../../../UI/SecBTN";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from "./Table.module.css";
import Modals from "../../../UI/Modals/Modals";
import Input from "../../../UI/Input/Input";
import Toast from "../../../UI/Toast/Toast";
import userService from "../../../app/services/user.service";

const DataTable = (props) => {
  const [showEntries, setShowEntries] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = +showEntries;

  const headers = [
    { name: "S.No.", field: "id", sortable: false },
    { name: "Task ID", field: "task_id", sortable: false },
    { name: "Request Time", field: "topicSequence", sortable: false },
    { name: "Respond Time", field: "action", sortable: false },
    { name: "Message", field: "action", sortable: false },
    { name: "Status", field: "status", sortable: false },
    { name: "Action", field: "status", sortable: false },
  ];

  const commentsData = useMemo(() => {
    // Get data from props
    let computedComments = [...props.data]; // Create a copy to avoid mutating props

    // First sort the data in ASCENDING order (reversed the sorting logic)
    computedComments = computedComments;

    // Then apply any search filters
    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.topic_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    // Apply user-selected sorting if any
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    // Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [props.data, currentPage, search, sorting, ITEMS_PER_PAGE]);

  //functions other than table
  const [dataToModal, setDataToModal] = useState({
    "topic_id": null,
    "topic_name": "",
    "topic_sequence": null,
    "status": null
  });

  const [index, setIndex] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);

  const onSaveHandler = () => {
    props.updateHandler(dataToModal);
    setShowPopUp(false);
  };

  const hideHandler = () => {
    setShowPopUp(false);
  };

  const editHandler = (topic_id, topic_name, topic_sequence, status) => {
    setDataToModal(() => {
      return {
        topic_id: topic_id,
        topic_name: topic_name,
        topic_sequence: topic_sequence,
        status: status,
      };
    });
    setShowPopUp(true);
    setIndex(index);
  };

  // Function to download file
  const DownloadFile = (taskId) => {
    // Prepare data for the API request
    const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
    const payload = {
      task_id: taskId,
      user_id: user_id
    };

    // Show loading state if needed
    // setIsLoading(true);

    userService
      .bulkQuestionTranslationData(payload)
      .then((res) => {
        console.log("Download API success", res.task_log);

        // Convert the response data to CSV
        if (res && Array.isArray(res.task_log)) {
          downloadCSV(res.task_log, `task_${taskId}_data.csv`);
        } else {
          // If the response is not in expected format, handle accordingly
          console.error("Unexpected response format", res);
          alert("Failed to download data: Unexpected format");
        }
      })
      .catch((err) => {
        console.error("Download API error", err);
        alert("Failed to download data.");
      })
      .finally(() => {
        // Hide loading state if needed
        // setIsLoading(false);
      });
  };

  const formatDateTime = (date) => {
    if (!date) return "";
  
    const d = new Date(date);
    const formattedDate = d.toLocaleDateString("en-GB");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
  
    return `${formattedDate} ${hours}:${minutes}`;
  };

  // Function to convert data to CSV and trigger download
  const downloadCSV = (data, filename) => {
    // Check if data exists and is an array
    if (!Array.isArray(data) || data.length === 0) {
      console.error("No data to download");
      alert("No data to download");
      return;
    }

    // Get headers from the first object
    const headers = Object.keys(data[0]);

    // Create CSV content
    let csvContent = headers.join(',') + '\n';

    // Add data rows
    data.forEach(item => {
      const row = headers.map(header => {
        // Handle cases where the value might contain commas or quotes
        const cell = item[header] === null || item[header] === undefined ? '' : item[header];
        const cellStr = String(cell);

        // If the cell contains commas, quotes, or newlines, enclose it in quotes
        if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
          // Replace any quotes with double quotes to escape them
          return `"${cellStr.replace(/"/g, '""')}"`;
        }
        return cellStr;
      }).join(',');

      csvContent += row + '\n';
    });

    // Create a Blob containing the CSV data
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    // Append to the document, trigger click, and clean up
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Toast />

      <div className="d-flex justify-content-between">
        <div>
          Show{" "}
          <select
            onChange={(e) => {
              setShowEntries(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>{" "}
          enteries
        </div>
        <Search
          onSearch={(value) => {
            setSearch(value);
            setCurrentPage(1);
          }}
        />
      </div>
      <div className="table-responsive">
        <table className="table table-bordered mt-3 mb-0">
          <TableHeader
            className={classes.header}
            headers={headers}
            onSorting={(field, order) => setSorting({ field, order })}
          />
          <tbody>
            {commentsData.length > 0 ? (
              commentsData.map((data, index) => (
                <tr key={data.task_id}>
                  <td >{index + 1}</td>
                  <td>{data.task_id}</td>
                  <td>{formatDateTime(data.req_time)}</td>
                  <td>{formatDateTime(data.res_time)}</td>
                  <td>{data.message}</td>
                  <td>
                    {data.status}
                  </td>
                  <td>
                    <SecBTN
                      onClick={() => DownloadFile(data.task_id)}
                      className="sec-btn1"
                      style={{ padding: "0.4rem 1rem", fontSize: "0.8rem" }}
                    >
                      <i className="fa fa-download mr-1"></i> Download
                    </SecBTN>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="text-center">
                  {props.noDataShow ? "No data Found !!" : ""}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <p className="small ">
        Showing{" "}
        <b>
          {props.data.length > 0
            ? (+showEntries < props.data.length
              ? +showEntries
              : props.data.length)
            : 0}
        </b>{" "}
        out of {props.data.length} enteries
      </p>
      {props.data.length > 0 && (
        <div className="mt-4">
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
    </>
  );
};

export default DataTable;